import React from 'react';
import { Badge } from '@/components/ui/badge';

const STATUS_MAP = {
  scheduled: { label: 'Agendada', className: 'bg-secondary text-secondary-foreground' },
  voting_open: { label: 'Votação Aberta', className: 'bg-[color:hsla(42,92%,52%,.22)] text-[var(--g66-amber-2)] border border-[color:hsla(42,92%,52%,.5)]' },
  voting_closed: { label: 'Votação Encerrada', className: 'bg-[color:hsla(220,14%,22%,.9)] text-white border border-border' },
  finished: { label: 'Finalizada', className: 'bg-[color:hsla(42,92%,52%,.14)] text-[var(--g66-amber)] border border-[color:hsla(42,92%,52%,.35)]' },
  cancelled: { label: 'Cancelada', className: 'bg-[color:hsla(0,78%,52%,.14)] text-[var(--g66-red-2)] border border-[color:hsla(0,78%,52%,.35)]' },
};

export function StageStatusBadge({ status }) {
  const m = STATUS_MAP[status] || { label: status, className: 'bg-secondary text-secondary-foreground' };
  return <Badge className={`${m.className} font-medium`}>{m.label}</Badge>;
}

const BAND_STATUS = {
  participante: { label: 'Participante', className: 'bg-secondary text-secondary-foreground' },
  classificada: { label: 'Classificada', className: 'bg-[color:hsla(42,92%,52%,.18)] text-[var(--g66-amber)] border border-[color:hsla(42,92%,52%,.35)]' },
  eliminada: { label: 'Eliminada', className: 'bg-[color:hsla(0,78%,52%,.14)] text-[var(--g66-red-2)] border border-[color:hsla(0,78%,52%,.35)]' },
  repescagem: { label: 'Repescagem', className: 'bg-[color:hsla(200,80%,50%,.14)] text-sky-300 border border-sky-500/30' },
  campea: { label: 'Campã', className: 'bg-[color:hsla(42,92%,52%,.22)] text-[var(--g66-amber-2)] border border-[color:hsla(42,92%,52%,.45)]' },
  inativa: { label: 'Inativa', className: 'bg-muted text-muted-foreground' },
};

export function BandStatusBadge({ status }) {
  const m = BAND_STATUS[status] || BAND_STATUS.participante;
  return <Badge className={`${m.className} font-medium`}>{m.label}</Badge>;
}

export function formatDatePt(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso.length === 10 ? iso + 'T12:00:00' : iso);
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: 'long', year: 'numeric', timeZone: 'America/Sao_Paulo' });
  } catch {
    return iso;
  }
}

export function formatDateShortPt(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso.length === 10 ? iso + 'T12:00:00' : iso);
    return d.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric', timeZone: 'America/Sao_Paulo' });
  } catch {
    return iso;
  }
}

export function formatDateTimePt(iso) {
  if (!iso) return '';
  try {
    const d = new Date(iso);
    return d.toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo' });
  } catch {
    return iso;
  }
}
